import React, { Component } from "react";
import { connect } from "react-redux";
import {
  withStyles,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import moment from "moment";

import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";
import Axios from "axios";
import { url } from "../../../config/config";
import { withRouter } from "react-router-dom";
import CustomTableHead from "../../../Component/Table/CustomTableHead/CustomTableHead";
import CustomLoader from "../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import CustomTableFooter from "../../../Component/Table/CutomTableFooter/CustomTableFooter";
import { useStyles } from "./PaymentHistory.css";
import MobilePaymentHistory from "./MobilePaymentHistory/MobilePaymentHistory";

class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 10,
      page: 0,
      column: [
        {
          name: "S.N.",
        },
        {
          name: "OrderId",
        },
        {
          name: "payVia",
        },
        {
          name: "Email",
        },
        {
          name: "PaymentId",
        },
        {
          name: "Total Price",
        },
        {
          name: "Date",
        },
      ],
      paymentDetails: [],
      isEmpty: false,
    };
  }

  componentDidMount() {
    this.getPaymentDetails(this.props.userToken);
  }

  getPaymentDetails = async (userToken) => {
    const response = await Axios.get(`${url}/api/sold/mybooks`, {
      headers: {
        "x-auth-token": userToken,
      },
    });
    if (response.data.length !== 0) {
      this.setState({
        paymentDetails: response.data,
        isEmpty: false,
      });
    } else {
      this.setState({
        paymentDetails: [],
        isEmpty: true,
      });
    }
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Header />
        <div className={classes.root}>
          <div style={{ fontSize: 30 }}>Payment History</div>
          <Divider />
          <br />
          {this.state.paymentDetails.length !== 0 ? (
            <div>
              <Paper className={classes.sectionDesktop}>
                <TableContainer>
                  <Table>
                    <CustomTableHead column={this.state.column} />
                    <TableBody>
                      {this.state.paymentDetails.map((payment, index) => (
                        <TableRow
                          key={index}
                          className={classes.tablerow}
                          onClick={() =>
                            this.props.history.push(
                              `/payment/details/${payment._id}`
                            )
                          }
                        >
                          <TableCell align="center">{index + 1}</TableCell>
                          <TableCell align="center">
                            {payment.orderId}
                          </TableCell>
                          <TableCell align="center">{payment.payVia}</TableCell>
                          <TableCell align="center">{payment.email}</TableCell>
                          <TableCell align="center">
                            {payment.paymentId}
                          </TableCell>
                          {payment.payVia === "paypal" ? (
                            <TableCell align="center">
                              $ {payment.totalPrice}
                            </TableCell>
                          ) : (
                            <TableCell align="center">
                              Rs. {payment.totalPrice}
                            </TableCell>
                          )}
                          <TableCell align="center">
                            {moment(new Date(payment.createdAt)).format("LL")}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>

                    <CustomTableFooter
                      count={this.state.paymentDetails.length}
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.page}
                      onChangePage={this.handlePage}
                      onChangeRowsPerPage={this.handleRowsPerPage}
                    />
                  </Table>
                </TableContainer>
              </Paper>
              <div className={classes.sectionMobile}>
                <MobilePaymentHistory payments={this.state.paymentDetails} />
              </div>
            </div>
          ) : this.state.isEmpty === true ? (
            <CustomEmptyMessage
              button={true}
              message="You haven't bought any books."
              buttonLabel="Start Buying"
              buttonUrl={() => this.props.history.push("/books")}
            />
          ) : (
            <CustomLoader />
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(PaymentHistory)));
